export default __webpack_public_path__ + "static/illustration-gh-integration-59420bcf0bea8cf535ae6846dac4e46a.svg";